import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { List } from 'immutable';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';
import { ChartConfiguration,ChartType, ChartTypeRegistry } from 'chart.js';

interface IRow {
  name: string;
  size?: string;
  category?: string;
  brand?: string;
  supplier?: string;
  numSold: number;
  total: number;
}

interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
};

@Component({
  selector: 'app-product-report',
  templateUrl: './product-report.page.html',
  styleUrls: ['./product-report.page.scss'],
})
export class ProductReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public cols: primeNgCol[];

  public stylistID: number;

  public wordCloudData: CloudData[];

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public barChartColors: object[] = [];

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public groupBy: string;

  public barChartValue: string = 'Count';

  public barChartSelectOptions: Array<string> = ['Count', 'Price'];

  public groupByOptions = [
    { label: 'Product', value: 'product' },
    { label: 'Category', value: 'category' },
    { label: 'Brand', value: 'brand' },
    { label: 'Supplier', value: 'supplier' },
  ];
  public options: CloudOptions;

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    indexAxis: 'y'
  }
  public barChartPriceOptions: ChartConfiguration<'bar'>['options']

  public barChartLabels: string[] = [];

  public barChartType: keyof MyChartTypeRegistry = 'bar';

  public barChartDataByCount: Array<{ data: Array<number>; label: string }> = [
    { data: [], label: 'Number sold' },
  ];

  public barChartDataByPrice: Array<{ data: Array<number>; label: string }> = [
    { data: [], label: 'Price amount' },
  ];

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: [{ data: [], label: 'Number sold', backgroundColor:[], borderColor:[] }],
  };

  public barChartPriceData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: [{ data: [], label: 'Number sold', backgroundColor:[], borderColor:[] }],
  };

  public backgroundColor = [];
  public borderColor = [];

  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private ChartsService: ChartsService,
    private router: Router,
    private CalendarService: CalendarService // , // private googleAnalytics: GoogleAnalytics
  ) {
    this.options = {
      height: 300,
      overflow: false,
    };


    for (let i = 0; i < 10; i++) {
      const r = Utilities.colorSpectrumRGB[i][0];
      const g = Utilities.colorSpectrumRGB[i][1];
      const b = Utilities.colorSpectrumRGB[i][2];

      this.barChartColors.push(
        ChartsService.chartColorArrayFunction(r, g, b, 0.8)
        );

        this.backgroundColor.push(`rgba(${r}, ${g}, ${b}, 0.8)`)
        this.borderColor.push(`rgba(${r}, ${g}, ${b}, 1)`)
      }

    // this.barChartOptions = ChartsService.barChartOption(
    //   '',
    //   'bottom'
    // );
    // this.barChartOptions.tooltips = { callbacks: this.tooltipCallbacks };
    // this.barChartOptions.legend.labels = {
    //   usePointStyle: false,
    //   boxWidth: 0
    // }
    // this.barChartOptions.scales.xAxes = [{
    //   gridLines: {
    //     display: true
    //   },
    //   ticks: {
    //     stepSize: 1,
    //     beginAtZero: true
    //   },
    //   scaleLabel: {
    //     display: true,
    //     labelString: ''
    //   }
    // }]
    // this.barChartOptions.scales.yAxes = [{
    //   gridLines: {
    //     display: false
    //   },
    //   ticks: {
    //     precision: 0,
    //     beginAtZero: true
    //   }
    // }]
    this.wordCloudData = [];
    this.stats = [];
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'size', header: 'Size' },
      { field: 'category', header: 'Category' },
      { field: 'brand', header: 'Brand' },
      { field: 'supplier', header: 'Supplier' },
      { field: 'numSold', header: '# Sold' },
      { field: 'total', header: '$ Sold' },
    ];

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() || user.getCanViewReports() === 1
      );
    }
    this.groupBy = 'product';
  }


  public ngOnInit() {
    const currency = this.userService.getSalon().getCurrency();

    this.barChartPriceOptions = {
      indexAxis: 'y',
      scales:{
        x: {
          ticks: {
            callback: function (value, index, values) {
              return Utilities.decodeHTML(currency) + value;
            },
          },
        },
      },
      plugins:{
        tooltip: {
          callbacks: {
            label: (context) => {
              return (
                context.dataset.label +
                ': ' +
                context.parsed.x +
                Utilities.decodeHtml(this.userService.getSalon().getCurrency())
              );
            },
          }
        }
      }
    };
    // this.googleAnalytics.trackView('ProductReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
  }
  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
    }
  }
  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate, this.groupBy);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.groupBy = dateRange.groupBy;

    this.timeManager(dateRange.start, dateRange.end);
    this.loadStats(this.stylist, this.startDate, this.endDate, this.groupBy);
  }

  public summaryTotalSold() {
    return this.stats
      .map((row) => row['total'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryNumSold() {
    return this.stats
      .map((row) => row['numSold'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public loadStats(
    stylist: Stylist,
    startDate: Date,
    endDate: Date,
    groupBy: string = 'daily'
  ) {
    this.timeManager(startDate, endDate);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    let tempWordCloudData: CloudData[] = [];
    this.reportService
      .loadProductStats(stylist.id, startDate, endDate, groupBy)
      .subscribe({
        next: (rows) => {
          this.stats = rows;
          let labelDataArray: Array<{
            label: string;
            data: number;
            price: number;
          }> = [];
          this.barChartDataByCount = [{ data: [], label: 'Number sold' }];
          this.barChartDataByPrice = [{ data: [], label: 'Price amount' }];
          let labels: Array<string> = [];
          let maxNumberSold: number = 0;
          this.barChartValue = 'Count';
          const topTenStats = this.stats.slice(0, 10);

          topTenStats.forEach((stat, index) => {
            let label: string = '';
            let wordCloudObj = {
              text: '',
              weight: stat.numSold,
              rotate: 45 * Utilities.returnRand(3),
              color: `rgb(${Utilities.colorSpectrumRGB[index][0]}, ${Utilities.colorSpectrumRGB[index][1]}, ${Utilities.colorSpectrumRGB[index][2]})`,
            };
            if (this.groupBy === 'product') {
              label = stat.name;
              wordCloudObj.text = stat.name;
            } else if (this.groupBy === 'category') {
              label = stat.category;
              wordCloudObj.text = stat.category;
            } else if (this.groupBy === 'brand') {
              label = stat.brand;
              wordCloudObj.text = stat.brand;
            } else if (this.groupBy === 'supplier') {
              label = stat.supplier;
              wordCloudObj.text = stat.supplier;
            }
            if (labels.indexOf(label) === -1) {
              labels.push(label);
              labelDataArray.push({
                label,
                data: stat.numSold,
                price: stat.total,
              });
            } else {
              labelDataArray[labels.indexOf(label)].data += stat.numSold;
            }
            if (maxNumberSold < labelDataArray[labels.indexOf(label)].data) {
              maxNumberSold = labelDataArray[labels.indexOf(label)].data;
            }
            tempWordCloudData.push(wordCloudObj);
          });
          labels = [];
          labelDataArray.forEach((labelData) => {
            this.barChartDataByCount[0].data.push(labelData.data);
            this.barChartDataByPrice[0].data.push(labelData.price);
            labels.push(labelData.label);
          });
          this.barChartLabels = labels;
          this.barChartData.labels = this.barChartLabels;
          this.barChartData.datasets = this.barChartDataByCount;
          this.barChartData.datasets[0].backgroundColor =this.backgroundColor;
          this.barChartData.datasets[0].borderColor = this.borderColor;
          this.barChartPriceData.labels = this.barChartLabels;
          this.barChartPriceData.datasets = this.barChartDataByPrice;
          this.barChartPriceData.datasets[0].backgroundColor =this.backgroundColor;
          this.barChartPriceData.datasets[0].borderColor = this.borderColor;

          this.wordCloudData = tempWordCloudData;

          this.isLoading = false;
          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          //this.content.resize();
        },
      });
  }
  public timeManager(dateRangeStart, dateRangeEnd) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;
  }

  public onBarChartValueSelected(event) {
    // if (event === 'Count') {
    //   this.barChartData.datasets[0] = this.barChartDataByCount[0];
    // } else {
    //   this.barChartData.datasets[0]= this.barChartDataByPrice[0]
    // }
  }

  public exportPdf() {
    this.ExportTableService.exportPdf(
      [
        ...this.stats.map((stat) => {
          return {
            name: stat.name,
            size: stat.size,
            category: stat.category,
            brand: stat.brand,
            supplier: stat.supplier,
            numSold: stat.numSold,
            total: stat.total,
          };
        }),
        {
          name: 'Total',
          size: '',
          category: '',
          brand: '',
          supplier: '',
          numSold: this.summaryNumSold(),
          total: this.summaryTotalSold(),
        },
      ],
      'Products',
      this.cols
    );
  }
  public exportExcel() {
    this.ExportTableService.exportExcel(
      [
        ...this.stats.map((stat) => {
          return {
            name: stat.name,
            size: stat.size,
            category: stat.category,
            brand: stat.brand,
            supplier: stat.supplier,
            numSold: stat.numSold,
            total: stat.total,
          };
        }),
        {
          name: 'Total',
          size: '',
          category: '',
          brand: '',
          supplier: '',
          numSold: this.summaryNumSold(),
          total: this.summaryTotalSold(),
        },
      ],
      'Products',
      this.cols.map((col) => col.header)
    );
  }
  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
